import React from 'react';
import { FaCcStripe, FaCcVisa } from 'react-icons/fa';
import { FaCcMastercard } from 'react-icons/fa';
import { FaCcAmex } from 'react-icons/fa6';
import { LiaCcJcb } from 'react-icons/lia';

const PaymentBadges = () => {
  return (
    <div className="w-full text-4xl text-gray-700">
      <p className="uppercase text-base text-center">
        {' '}
        Checkout Securely with:{' '}
      </p>
      <div className=" flex flex-row justify-center space-x-7 mb-2">
        <FaCcVisa />
        <FaCcMastercard />
        <FaCcAmex />
        <LiaCcJcb />
        <FaCcStripe />
      </div>
    </div>
  );
};

export default PaymentBadges;
